import { useEffect, useState } from "react";
import ApiService from "../services/api";
import type { Charity } from "../types";

export const useCharities = () => {
	const [charities, setCharities] = useState<Charity[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchCharities = async () => {
			try {
				setLoading(true);
				setError(null);
				const data = await ApiService.getPartnerCharities();
				setCharities(data);
			} catch (err) {
				setError(
					err instanceof Error ? err.message : "Failed to fetch charities",
				);
				console.error("Error fetching charities:", err);
			} finally {
				setLoading(false);
			}
		};

		fetchCharities();
	}, []);

	return { charities, loading, error };
};
